import * as React from 'react'
import { CreateInvoiceDetail } from '../InvoiceDetailStore'
import { message, notification } from 'antd'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { API, InvoiceStatus } from '@getgreenline/homi-shared'
import { parseErrorMsg } from '../../../../../utilities/helpers'
import { PurchaseOrderModal } from '../../../../../HOC/PurchaseOrderOptionButtons/PurchaseOrderModal'
import { BlazeButton } from '../../../../../components/CustomButtons/BlazeButton'

interface Props {
  title: string
  className?: string
  widthBreakPoint?: number
  createInvoice: CreateInvoiceDetail
}

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

export const CancelInvoiceDetailButton = inject('currentCompanyStore')(
  observer((props: Props & InjectedProps) => {
    const { title, className, widthBreakPoint, createInvoice, currentCompanyStore } = props
    const companyId = currentCompanyStore!.company!.id
    const invoiceId = createInvoice.invoiceDetail && createInvoice.invoiceDetail.id

    const [isModalVisible, setIsModalVisible] = React.useState(false)
    const [isCancelling, setIsCancelling] = React.useState(false)

    const cancelInvoiceDetail = async () => {
      if (!invoiceId) {
        return
      }

      setIsCancelling(true)

      try {
        const updatedInvoice = await API.cancelInvoice(companyId, invoiceId)

        setIsCancelling(false)
        setIsModalVisible(false)

        createInvoice.setInvoiceDetail(updatedInvoice)
        createInvoice.populate(updatedInvoice)

        message.success('Purchase order cancelled!')
      } catch (error) {
        notification.error({
          message: 'Error',
          description: parseErrorMsg(error),
          duration: 0,
          top: 55,
        })

        setIsCancelling(false)
      }
    }

    return (
      <React.Fragment>
        <BlazeButton
          buttonProps={{
            type: 'danger',
            disabled: isCancelling,
            className,
            onClick: () => setIsModalVisible(true),
            loading: isCancelling,
          }}
          titleProps={{
            title,
            widthBreakPoint,
          }}
        />

        <PurchaseOrderModal
          visible={isModalVisible}
          createInvoice={createInvoice}
          updatingNewStatus={InvoiceStatus.CANCELLED}
          isStatusUpdating={isCancelling}
          setIsModalVisible={setIsModalVisible}
          updateStatus={cancelInvoiceDetail}
          setUpdatingNewStatus={() => {}}
        />
      </React.Fragment>
    )
  }),
)
